import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { AppCard, AppCardSlot, AppGrid } from './AppCard';
import {
  IconAppFinances,
  IconAppGithub,
  IconAppLibrary,
  IconPencilSquare,
} from './icons';

const sample: Dictionary<{ library: string; finances: string; edit: string }> =
  {
    pl: { library: 'Biblioteka', finances: 'Finanse', edit: 'Edytuj link' },
    en: { library: 'Library', finances: 'Finances', edit: 'Edit link' },
  };

export default {
  kind: 'component',
  title: { pl: 'Karta aplikacji', en: 'App card' },
  description: {
    pl: 'Ikona nad nazwą, w siatce `AppGrid`: dwie w rzędzie na telefonie, trzy od sm. `external` otwiera link w nowej karcie. `AppCardSlot` to mniejsza karta z akcjami w rogu, widocznymi po najechaniu lub fokusie.',
    en: 'An icon over a name, in an `AppGrid`: two up on a phone, three from sm. `external` opens the link in a new tab. `AppCardSlot` is a smaller card with actions in its corner, shown on hover or focus.',
  },
  variants: [
    {
      name: { pl: 'Launcher', en: 'Launcher' },
      render: (locale) => (
        <AppGrid>
          <AppCard
            to="/library/app-card"
            icon={<IconAppLibrary />}
            title={sample[locale].library}
          />
          <AppCard
            to="/library/app-card"
            icon={<IconAppFinances />}
            title={sample[locale].finances}
          />
        </AppGrid>
      ),
    },
    {
      name: { pl: 'Z akcjami', en: 'With actions' },
      render: (locale) => (
        <AppGrid>
          <AppCardSlot
            actions={
              <button
                type="button"
                className="btn-icon-ghost btn-icon-overlay"
                aria-label={sample[locale].edit}
              >
                <IconPencilSquare />
              </button>
            }
          >
            <AppCard
              to="https://github.com"
              external
              icon={<IconAppGithub />}
              title="GitHub"
            />
          </AppCardSlot>
        </AppGrid>
      ),
    },
  ],
} satisfies Story;
